<template>
  <button type="button" class="text-3xl text-orange-500">
    <font-awesome-icon :icon="['fas', 'bars']" />
  </button>
</template>
